import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Artists from './components/Artists';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navigation from '../../components/feature/Navigation';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <Services />
      <Artists />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
